import { InputGroup } from '@chakra-ui/react';
import { FormInput } from 'components/ui/form/Input';
import { InputFilterOptionProps } from '../types/FilterOption';

type FilterInputProps = InputFilterOptionProps;

export const InputOption = ({
  id,
  label,
  value,
  onChange,
  disabled,
  icon,
  onClear,
}: FilterInputProps): React.ReactElement => {
  return (
    <InputGroup>
      <FormInput
        type="text"
        id={id}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={label}
        disabled={disabled}
        leftElement={icon ?? undefined}
        clearable={!!value && !!onClear}
        onClear={onClear}
      />
    </InputGroup>
  );
};
